import { Button, Col, Drawer, Row, Spin } from "antd";
import style from "./index.module.scss";
import React, { useEffect, useMemo, useState } from "react";
import { DrawerProps } from "antd/es/drawer";
import {
    CopyDetailProps,
    getCopyPaper,
    getHomeWorkPaperListProps
} from "../../../../../../../service/homework";
import useRequestFn from "../../../../../../../utils/useRequestFn";
import {
    date2Week,
    getQuestionTypeName
} from "../../../../../../../service/service";
import BadRender from "../BadRender";

interface DrawerModalProps extends DrawerProps {
    PAY_LOAD?: getHomeWorkPaperListProps;
    onClose: () => void;
    onSubmit: (key: string | null) => void;
}
export function DrawViewCopyModal({
    PAY_LOAD,
    onClose,
    onSubmit,
    ...reset
}: DrawerModalProps) {
    const [haveTop, { loading: haveLoading }] = useRequestFn(getCopyPaper);

    const [viewData, setViewData] = useState<CopyDetailProps[]>();

    useEffect(() => {
        if (PAY_LOAD) {
            haveTop({
                courseNo: PAY_LOAD?.courseNo,
                continunity: PAY_LOAD?.continunity,
                courseSeq: PAY_LOAD?.courseSeq,
                section: PAY_LOAD?.section,
                week: date2Week(PAY_LOAD?.createTime).toString(),
                weekTime: PAY_LOAD?.week,
                weekTimeId: String(PAY_LOAD?.weekTimeId),
                batchNo: PAY_LOAD?.batchNo
            }).then(res => {
                setViewData(res);
            });
        }
    }, [PAY_LOAD]);

    const title = useMemo(() => {
        return (
            <div className={style.title}>
                <h3>
                    {`${PAY_LOAD?.courseName}[${PAY_LOAD?.courseNo}-${PAY_LOAD?.courseSeq}]`}
                </h3>
                <p>创建时间：{PAY_LOAD?.createTime}</p>
            </div>
        );
    }, [PAY_LOAD]);

    function sub() {
        onSubmit(PAY_LOAD?.key || null);
        onClose();
    }

    return (
        <Drawer
            width={720}
            {...reset}
            title={title}
            onClose={onClose}
            className={style.drawer}
            destroyOnClose>
            <Spin spinning={haveLoading}>
                {viewData?.map((item, index) => (
                    <div key={item.topicId}>
                        <div key={index} className={style.block}>
                            <div className={style.header}>
                                <b>{getQuestionTypeName(item.topicType)}</b>{" "}
                                (本小题 {item.score} 分)
                            </div>
                            <BadRender item={item} index={index} />
                        </div>
                    </div>
                ))}
            </Spin>

            <div className={style.footer}>
                <div className={style.score}>总分：{PAY_LOAD?.score}分</div>

                <Row
                    type="flex"
                    style={{ width: 400 }}
                    justify="end"
                    gutter={15}>
                    <Col>
                        <Button onClick={onClose}>取消</Button>
                    </Col>
                    <Col>
                        <Button
                            type="primary"
                            loading={haveLoading}
                            onClick={sub}>
                            确定复制作业
                        </Button>
                    </Col>
                </Row>
            </div>
        </Drawer>
    );
}
